import React, { useEffect } from 'react';
import './CustomAlertCf.css';
import logocontalearn from '../imagesHome/logoconta.png';

const CustomAlertCf = ({ onConfirm, onCancel }) => {
  useEffect(() => {
    document.body.classList.add('modal-open-cf');
    return () => {
      document.body.classList.remove('modal-open-cf');
    };
  }, []);

  return (
    <div className="duo-alert-overlay-cf">
      <div className="duo-alert-box-cf">
        <img src={logocontalearn} alt="duo" className="duo-mascot-cf" />
        <h2 className="duo-title-cf">Stai, nu pleca!</h2>
        <p className="duo-text-cf">Iti vei pierde progresul daca iesi acum</p>
        <div className="duo-buttons-cf">
          <button className="btn-primary-duo-cf" onClick={onCancel}>Continua sa inveti</button>
          <button className="btn-link-duo-cf" onClick={onConfirm}>Incheie sesiunea</button>
        </div>
      </div>
    </div>
  );
};

export default CustomAlertCf;
